<template>
  <v-dialog :value="value" @input='$listeners.input'>
     <v-card flat class='d-flex flex-column fill-height'> 
      <v-card-title>{{$t('accesibility')}}</v-card-title>
      <v-card-text>
        <div class="d-flex my-1 align-center"><span class="mr-2">{{$t('dark_mode')}}</span><dark-mode-switch/></div>
        <div class="d-flex my-1 align-center"><span class="mr-2">{{$t('language')}}</span><locale-select-global/></div>
      </v-card-text>
      <v-divider/>  
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';
import darkModeSwitch from './darkModeSwitch.vue';
import LocaleSelectGlobal from './LocaleSelectGlobal.vue';
import SpeedSliderGlobal from './tts/SpeedSliderGlobal.vue';
import VoiceSelectGlobal from './tts/VoiceSelectGlobal.vue';
import userAgent from '../utils/userAgent';

export default defineComponent({
  components: { 
    darkModeSwitch, 
    SpeedSliderGlobal, 
    VoiceSelectGlobal,
    LocaleSelectGlobal,
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  setup(){
    return { userAgent }
  }
})
</script>